import React from "react";
import * as yup from "yup";
import UiInput, {
  UiInputPasswordWithFinalForm,
} from "../../../../_uiComponents/UiInput";
import { useDispatch, useSelector } from "react-redux";
import { UiButton } from "../../../../_uiComponents/common/UiButton";
import { UiValidationMessage } from "../../../../_uiComponents/common/UiValidationMessage";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { expiredPasswordChangeValueRequest } from "../../../../../_redux/_actions";
import Validator from "../../../../../_helpers/validate.schema";
import { passwordValidatePolicy } from "../../../../../_helpers/support.services";
import { specialCharactersCheck } from "../../../../../_helpers/support.services";
import { commonConstants } from "../../../../../_redux/_constants";

export const ResetPasswordForm = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const validateSchema = () =>
    yup.object().shape({
      newPassword: yup
        .string()
        .matches(
          /^[A-Za-z\d!#$%&*()@^+=]+$/,
          t("Some special characters are not allowed."),
        )
        .required(t("This field is required")),
      confirmPassword: yup.string().when("newPassword", {
        is: (val) => passwordValidatePolicy(val),
        then: (schema) => schema.required(t("This field is required")),
        otherwise: (schema) => schema.notRequired(),
      }),
    });

  const { lang } = useSelector((state) => {
    return {
      lang: state?.lang,
    };
  });

  const onSubmit = async (values) => {
    const payload = {
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
      isResetRequestByAdmin: commonConstants.IS_RESET_REQUEST_BY_ADMIN_YES,
      locale: lang?.defaultLang,
    };
    dispatch(expiredPasswordChangeValueRequest(payload));
  };

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  const handleButtonClick = (handleSubmit) => {
    handleSubmit();
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={onValidate}
      subscription={{ values: true, hasValidationErrors: true }}
      render={({ handleSubmit, values, form, hasValidationErrors }) => {
        const isPasswordValid = passwordValidatePolicy(values.newPassword);
        React.useEffect(() => {
          if (!isPasswordValid && values.confirmPassword) {
            form.change("confirmPassword", "");
          }
        }, [isPasswordValid, values.confirmPassword, form]);

        return (
          <form onSubmit={handleSubmit}>
            <UiInputPasswordWithFinalForm
              name="newPassword"
              id="setting-change-password-field"
              label={t("Password")}
              type="password"
              minLength="8"
              maxLength="32"
              varient="outlined"
              required
              passwordValidatePolicy={passwordValidatePolicy}
              specialCharactersCheck={specialCharactersCheck}
              enableStrength
              enableConditions
            />

            <div className={!isPasswordValid ? "df-reset-pw-form" : ""}>
              <UiInput
                name="confirmPassword"
                id="setting-change-password-confirm-password-field"
                label={t("Confirm Password")}
                required
                type="password"
                maxLength="32"
                varient="outlined"
                disabled={!isPasswordValid}
              />
            </div>

            {isPasswordValid &&
              values.confirmPassword &&
              values.confirmPassword !== values.newPassword && (
                <UiValidationMessage
                  message={t("Both passwords do not match.")}
                />
              )}

            <UiButton
              className="df-ui-dark-bg-btn w-100 mt-2"
              name={t("Next")}
              type="button"
              disabled={
                hasValidationErrors ||
                !isPasswordValid ||
                values.confirmPassword !== values.newPassword
              }
              onClick={() => handleButtonClick(handleSubmit)}
            />
          </form>
        );
      }}
    />
  );
};
